/** PM Pagination — paginated view mode for message threads. */

// ─── Paginated view ─────────────────────────────────────────────

/**
 * Toggle between chat view and paginated view.
 */
window.togglePagedView = function() {
  // Close the actions menu
  $("#conversation-actions-menu").addClass("hidden");

  if (window.pagedViewActive) {
    window.deactivatePagedView();
  } else {
    window.activatePagedView();
  }
};

/**
 * Switch to paginated view mode.
 */
window.activatePagedView = function() {
  var threadId = window.get_active_thread_id();
  if (!threadId) return;

  window.pagedViewActive = true;
  localStorage.setItem('pm_paged_view', '1');

  $("#jump-to-latest-btn").addClass("hidden").removeClass("flex");
  // Paged view shows the newest page, never a date-jump slice.
  window.calendarJump?.resetDateJump();

  // Update menu label
  window.updatePagedViewLabel();

  // Load page 1 (newest messages)
  window.loadPagedMessages(1);
};

/**
 * Switch back to chat (infinite scroll) view mode.
 */
window.deactivatePagedView = function() {
  window.pagedViewActive = false;
  localStorage.setItem('pm_paged_view', '0');

  // Update menu label
  window.updatePagedViewLabel();

  // Reload thread in chat mode
  var threadId = window.get_active_thread_id();
  if (threadId) {
    window.view_thread(threadId, true);
  }
};

/**
 * Load a specific page of messages.
 * @param {number} page - Page number, 1 for the newest page
 */
window.loadPagedMessages = function(page) {
  var threadId = window.get_active_thread_id();
  if (!threadId) return;

  var seq = window.pagedViewRequestSeq = (window.pagedViewRequestSeq || 0) + 1;
  // A newer paged request or abandonPagedLoad takes over both flags.
  var settle = function() {
    if (seq === window.pagedViewRequestSeq) {
      window.pm_ajax_request_active = 0;
      window.pagedViewLoadPending = false;
    }
  };

  window.pm_ajax_request_active = 1;
  // update_pm_info holds its polls until this settles (pm/polling.js).
  window.pagedViewLoadPending = true;
  $.ajax({
    type: "POST",
    url: "/app/messages/load-paged",
    data: { thread: threadId, page: page },
    dataType: "json",
    timeout: 30000
  }).done(function(data) {
    // jQuery skips the callbacks after one that throws, so .always() cannot settle.
    try {
      renderPagedMessages(data, threadId, seq);
    } finally {
      settle();
    }
  }).fail(settle);
};

/**
 * Drop the response of an in-flight paged load or poll, and release the flags of a
 * pending paged load. Call before any action that replaces or empties #threads_right.
 */
window.abandonPagedLoad = function() {
  window.pagedViewRequestSeq = (window.pagedViewRequestSeq || 0) + 1;
  if (!window.pagedViewLoadPending) return;
  window.pagedViewLoadPending = false;
  window.pm_ajax_request_active = 0;
};

function renderPagedMessages(data, threadId, seq) {
  // Only the latest paged request for the open thread renders. Scroll view, a date
  // jump, a closed thread or another open thread makes the response stale.
  if (seq !== window.pagedViewRequestSeq || !window.pagedViewActive
    || String(window.get_active_thread_id()) !== String(threadId)) {
    return;
  }
  if (data.error) {
    return;
  }
  // The paged view re-renders the open thread, so it carries a fresh token.
  window.storeThreadTypingToken?.(threadId, data);
  if (!data.body) {
    return;
  }

  var c = $("#threads_right");
  // update_pm_info appends incoming messages only to a rendered page 1 (pm/polling.js).
  var newWrapper = $('<div id="messages_wrapper"></div>').attr('data-paged-page', data.page);
  newWrapper.append(data.body);
  var touch = Boolean(window.matchMedia && window.matchMedia('(any-pointer: coarse)').matches);
  var compact = window.innerWidth < 640 || c.get(0).clientWidth < PAGED_NUMBERS_MIN_PANE_WIDTH;
  newWrapper.append(window.pagedViewControlsHtml(data.page, data.total_pages, compact, touch || compact));
  var oldWrapper = c.find('#messages_wrapper');
  if (oldWrapper.length) {
    oldWrapper.replaceWith(newWrapper);
  } else {
    c.empty().append(newWrapper);
  }

  // scrollTop 0 is the bottom of the column-reverse pane, where the control sits.
  c.get(0).scrollTop = 0;

  if (data.contact_status) window.update_header_status(data.contact_status);
  if (data.contact_active === false) {
    $("#threads_right_bottom").addClass("hidden");
    if (data.contact_name) {
      $("#current_thread_username").text(data.contact_name);
    }
  }

  // Initialize icons and audio players in new content
  if (window.LucideIcons) window.LucideIcons.initialize(newWrapper.get(0));
  if (window.initAudioPlayers) window.initAudioPlayers();
}

// The numbered layout with 44px targets needs about this much pane width.
var PAGED_NUMBERS_MIN_PANE_WIDTH = 520;

/**
 * Build the page control that follows the last message of a page, in the
 * message flow. Returns '' for a single-page thread.
 * append_msgs (pm/polling.js) inserts new messages before #paged-view-controls.
 * @param {number} current - Current page number
 * @param {number} total - Total number of pages
 * @param {boolean} compact - Show "< N / M >" in place of page numbers
 * @param {boolean} touchTargets - Use 44px targets
 * @returns {string}
 */
window.pagedViewControlsHtml = function(current, total, compact, touchTargets) {
  if (!(total > 1)) return '';

  var html = '';
  var size = touchTargets ? 'h-11 min-w-11 ' : 'h-8 min-w-8 ';
  var itemBase = 'inline-flex items-center justify-center ' + size + 'px-2 rounded-full text-sm ';
  var btnNormal = itemBase + 'transition-colors duration-150 border-0 cursor-pointer text-gray-600 dark:text-gray-300 hover:bg-sky-100 dark:hover:bg-sky-900/40 hover:text-sky-600 dark:hover:text-sky-300 bg-transparent';
  var currentItem = itemBase + 'bg-sky-500 text-white shadow-sm';
  var edgeItem = itemBase + 'text-gray-300 dark:text-gray-600';

  if (current > 1) {
    html += '<button class="' + btnNormal + '" onclick="window.loadPagedMessages(' + (current - 1) + ')"'
      + ' aria-label="' + (window.t ? window.t('legacy.pm.previous_page') : 'Previous page') + '">'
      + '<i data-lucide="chevron-left" class="w-4 h-4"></i></button>';
  } else {
    html += '<span class="' + edgeItem + '"><i data-lucide="chevron-left" class="w-4 h-4"></i></span>';
  }

  if (compact) {
    html += '<span class="text-xs text-gray-500 dark:text-gray-400 px-1.5">' + window.formatCompactPaginationNumber(current) + ' / ' + window.formatCompactPaginationNumber(total) + '</span>';
  } else {
    var pages = window.getPaginationPages(current, total);
    for (var i = 0; i < pages.length; i++) {
      var p = pages[i];
      if (p === '...') {
        html += '<span class="text-gray-400 dark:text-gray-500 px-0.5 text-xs">...</span>';
      } else if (p === current) {
        html += '<span class="' + currentItem + '" aria-current="page">' + window.formatCompactPaginationNumber(p) + '</span>';
      } else {
        html += '<button class="' + btnNormal + '" onclick="window.loadPagedMessages(' + p + ')">' + window.formatCompactPaginationNumber(p) + '</button>';
      }
    }
  }

  if (current < total) {
    html += '<button class="' + btnNormal + '" onclick="window.loadPagedMessages(' + (current + 1) + ')"'
      + ' aria-label="' + (window.t ? window.t('legacy.pm.next_page') : 'Next page') + '">'
      + '<i data-lucide="chevron-right" class="w-4 h-4"></i></button>';
  } else {
    html += '<span class="' + edgeItem + '"><i data-lucide="chevron-right" class="w-4 h-4"></i></span>';
  }

  return '<div id="paged-view-controls" class="flex justify-center py-3">'
    + '<nav class="flex items-center justify-center gap-1 bg-white dark:bg-gray-800 rounded-full shadow-sm border border-gray-200 dark:border-gray-700 px-2 py-1.5"'
    + ' aria-label="' + (window.t ? window.t('common.pagination_aria') : 'Page navigation') + '">'
    + html + '</nav></div>';
};

window.formatCompactPaginationNumber = function(value) {
  var number = Number(value) || 0;
  if (number >= 1000000) {
    return (Math.floor(number / 100000) / 10).toFixed(1).replace(/\.0$/, '') + 'm';
  }
  if (number >= 10000) {
    return Math.floor(number / 1000) + 'k';
  }
  if (number >= 1000) {
    return (Math.floor(number / 100) / 10).toFixed(1).replace(/\.0$/, '') + 'k';
  }

  return String(number);
};

/**
 * Generate array of page numbers to display, with ellipsis for gaps.
 * Always shows first, last, and 2 pages around current.
 * @param {number} current
 * @param {number} total
 * @returns {Array<number|string>}
 */
window.getPaginationPages = function(current, total) {
  if (total <= 7) {
    var arr = [];
    for (var i = 1; i <= total; i++) arr.push(i);
    return arr;
  }

  var pages = [];
  var rangeStart = Math.max(2, current - 2);
  var rangeEnd = Math.min(total - 1, current + 2);

  pages.push(1);
  if (rangeStart > 2) pages.push('...');
  for (var j = rangeStart; j <= rangeEnd; j++) pages.push(j);
  if (rangeEnd < total - 1) pages.push('...');
  pages.push(total);

  return pages;
};

/**
 * Update the paginated/chat view toggle label and icon.
 */
window.updatePagedViewLabel = function() {
  var label = document.getElementById('toggle-paged-view-label');
  var btn = document.getElementById('toggle-paged-view-btn');
  if (!label || !btn) return;

  var icon = btn.querySelector('[data-lucide]');
  /* lucide-icons: message-circle, book-open */
  var iconName;
  if (window.pagedViewActive) {
    label.textContent = window.t ? window.t('legacy.pm.chat_view') : 'Scroll view';
    iconName = 'message-circle';
  } else {
    label.textContent = window.t ? window.t('legacy.pm.paginated_view') : 'Paginated view';
    iconName = 'book-open';
  }
  if (icon && window.LucideIcons) window.LucideIcons.swap(icon, iconName);
};
